import ContentLoader from "react-content-loader"
const TableLoader = () => {
    return (
        <div className='loader_top_space'>
            <ContentLoader
                speed={1}
                width='100%'
                height={348}
                viewBox="0 0 1806 348"
                backgroundColor="#f3f3f3"
                foregroundColor="#e8ecf2"
            >
                <rect x="0" y="0" rx="6" ry="6" width="85" height="12" />
                <rect x="1132" y="0" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="0" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="0" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="0" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="0" rx="6" ry="6" width="76" height="12" />
                <rect x="1692" y="0" rx="6" ry="6" width="114" height="12" />
                <rect x="152" y="0" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="0" rx="6" ry="6" width="271" height="12" />
                <rect x="0" y="48" rx="6" ry="6" width="85" height="12" />
                <rect x="1132" y="48" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="48" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="48" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="48" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="48" rx="6" ry="6" width="76" height="12" />
                <rect x="1692" y="48" rx="6" ry="6" width="114" height="12" />
                <rect x="152" y="48" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="48" rx="6" ry="6" width="271" height="12" />
                <rect x="0" y="96" rx="6" ry="6" width="85" height="12" />
                <rect x="1132" y="96" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="96" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="96" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="96" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="96" rx="6" ry="6" width="76" height="12" />
                <rect x="1692" y="96" rx="6" ry="6" width="114" height="12" />
                <rect x="152" y="96" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="96" rx="6" ry="6" width="271" height="12" />
                <rect x="0" y="144" rx="6" ry="6" width="85" height="12" />
                <rect x="0" y="192" rx="6" ry="6" width="85" height="12" />
                <rect x="0" y="240" rx="6" ry="6" width="85" height="12" />
                <rect x="0" y="288" rx="6" ry="6" width="85" height="12" />
                <rect x="0" y="336" rx="6" ry="6" width="85" height="12" />
                <rect x="1132" y="144" rx="6" ry="6" width="76" height="12" />
                <rect x="1132" y="192" rx="6" ry="6" width="76" height="12" />
                <rect x="1132" y="240" rx="6" ry="6" width="76" height="12" />
                <rect x="1132" y="288" rx="6" ry="6" width="76" height="12" />
                <rect x="1132" y="336" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="144" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="192" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="240" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="288" rx="6" ry="6" width="76" height="12" />
                <rect x="955" y="336" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="144" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="192" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="240" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="288" rx="6" ry="6" width="76" height="12" />
                <rect x="1272" y="336" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="144" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="192" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="240" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="288" rx="6" ry="6" width="76" height="12" />
                <rect x="1411" y="336" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="144" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="192" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="240" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="288" rx="6" ry="6" width="76" height="12" />
                <rect x="1552" y="336" rx="6" ry="6" width="76" height="12" />
                <rect x="1692" y="144" rx="6" ry="6" width="114" height="12" />
                <rect x="1692" y="192" rx="6" ry="6" width="114" height="12" />
                <rect x="1692" y="240" rx="6" ry="6" width="114" height="12" />
                <rect x="1692" y="288" rx="6" ry="6" width="114" height="12" />
                <rect x="1692" y="336" rx="6" ry="6" width="114" height="12" />
                <rect x="152" y="144" rx="6" ry="6" width="271" height="12" />
                <rect x="152" y="192" rx="6" ry="6" width="271" height="12" />
                <rect x="152" y="240" rx="6" ry="6" width="271" height="12" />
                <rect x="152" y="288" rx="6" ry="6" width="271" height="12" />
                <rect x="152" y="336" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="144" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="192" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="240" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="288" rx="6" ry="6" width="271" height="12" />
                <rect x="539" y="336" rx="6" ry="6" width="271" height="12" />
            </ContentLoader>
        </div>
    )
}

export default TableLoader;